<template>
  <div v-show="alert">
    <h3 style="font-size: 1.2em">{{ alert.user.first_name }} {{ alert.user.last_name }}</h3>
    <span class="item-detail-title">{{ $t('users.phone') }}</span>
    <span>{{ alert.user.phone }}</span>
    <span class="item-detail-title">{{ $t('user_alert.time') }}</span>
    <span>{{ toLocalTime(alert.time) }}</span>
    <span class="item-detail-title">{{ $t('user_alert.location') }}</span>
    <span v-if="alert.location">{{ alert.location.y }} {{ alert.location.x }}</span>
    <span v-else>{{ $t('common.unknown') }}</span>
    <span class="item-detail-title">{{ $t('user_alert.contract') }}</span>
    <span v-if="alert.contract">{{ alert.contract.name }} {{ alert.contract.contract_number }}</span>
    <span v-else>-</span>
    <span class="item-detail-title">{{ $t('user_alert.company') }}</span>
    <span v-if="alert.company">{{ alert.company.name }}</span>
    <span v-else>-</span>
    <span class="item-detail-title">{{ $t('user_alert.type') }}</span>
    <span>{{ alertTypeName(alert.type) }}</span>
    <div class="col-sm-12 button-container">
      <button
        class="btn btn-sm btn-primary"
        @click.stop="resolveModal = true"
      >
        {{ $t('user_alert.resolve') }}
      </button>
    </div>
    <base-modal
      v-if="resolveModal"
      hide-footer
      :title="$t('user_alert.resolve_alert')"
      @close="resolveModal = false"
    >
        <div class="col-12">
            <span class="item-detail-title">{{ $t('user_alert.notes') }}</span>
            <textarea
                id="info"
                v-model="notes"
                class="form-control mb-2"
                rows="3"
            />
            <div class="button-container">
                <button
                    class="btn btn-sm btn-primary"
                    @click.stop="resolveAlert"
                >
                    {{ $t('user_alert.resolve') }}
                </button>
            </div>
        </div>
    </base-modal>
  </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin"
import UserAlert from "@/components/user/alert/UserAlert"
import {restApi} from "@/components/mixins/RestApiMixin"
import {timeUtils} from "../../mixins/TimeUtils"
import BaseModal from "@/components/BaseModal";

export default {
    name: "UserAlertEditor",
    components: {BaseModal},
    mixins: [mapHelper, restApi, timeUtils],
    data() {
        return {
            resolveModal: false,
            notes: ''
        }
    },
    props: {
        alert: {
            type: UserAlert,
            default: null
        }
    },
    emits: ['alertResolved'],
    methods: {
        alertTypeName(alertType) {
            switch (alertType) {
                case UserAlert.TYPE_AUTOMATIC:
                    return this.$t('user_alert.types.automatic')
                case UserAlert.TYPE_USER_INITIATED:
                    return this.$t('user_alert.types.user_initiated')
            }
            return '-'
        },
        async resolveAlert() {
            await this.alert.resolveAlert(this, this.notes)
            this.resolveModal = false
            this.$emit('alertResolved')
        }
    }
}
</script>

<style scoped>

</style>
